import React from "react";
import { Helmet } from "react-helmet";
import Fondo from "../img/ilustracioncusco.jpg";
import Fondo2 from "../img/Ilustración de Portada_Gustavo Guarnizo_Piura.jpg";
import Fondo3 from "../img/notaclarys.jpeg";
import Fondo4 from "../img/Ilustración de portada_Apurimac_edited.jpg";
import Fondo5 from "../img/Dibujo-4-Cerro-Verde.jpg";
import SocialShare from "../components/SocialShare";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Fondo6 from "../img/IlustraciónportadaLoreto.jpg";
import Fondo7 from "../img/Ilustración para portada_Moquegua.jpg";
import Fondo8 from "../img/Dibujo-oro-2.jpg";

const Home = () => {
  return (
    <>
      <Navbar />
      <div className="home">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Especial: Transparencia en las industrias extractivas</title>
          <meta
            property="og:title"
            content="Especial: Transparencia en las industrias extractivas"
          />
          <meta
            name="description"
            content="¿En qué se gasta el dinero proveniente de las regalías y el canon y sobrecanon minero? ¿Qué proyectos ejecuta el oriente con el canon petrolero?"
          ></meta>
          <meta property="og:url" content={process.env.REACT_APP_URL} />
          <meta property="og:image" content={Fondo} />
        </Helmet>
        <header className="d-flex flex-column justify-content-center align-content-center bg-light">
          <div className="container">
            <h2 className="text-center">ESPECIAL</h2>
            <h1 className="text-center">
              Transparencia en las industrias extractivas
            </h1>
            <SocialShare
              url={process.env.REACT_APP_URL}
              text="Transparencia en las industrias extractivas"
            />
            <p className="bajada">
              ¿En qué se gasta el dinero proveniente de las regalías y el canon
              y sobrecanon minero? ¿Qué proyectos ejecuta el oriente con el
              canon petrolero? ¿Realmente las universidades invierten el canon
              en investigación? ¿Qué tan transparentes y participativos son los
              procesos de monitoreo? ¿Qué tan ordenado está el Estado para
              monitorear la producción del oro en la minería artesanal? Son
              preguntas que se hicieron periodistas de las regiones de Arequipa,
              Apurímac, Cusco, Loreto, Piura y Moquegua. Las respuestas están en
              estas diez historias de investigación.
            </p>
          </div>
        </header>
        <section className="container">
          <div className="content-home">
            <h2 className="text-center">Investigaciones</h2>
            <div className="line-divider"></div>
            <div className="row justify-content-center text-center mb-4">
              <div className="col-sm-4 item-post">
                <a href="./pobreza-corrupcion-provincias-mineras-cusco">
                  <div className="container-img">
                    <img
                      src={Fondo}
                      alt="Pobreza y corrupción en dos provincias mineras del Cusco"
                    />
                  </div>

                  <h3 className="mt-2">
                    Pobreza y corrupción en dos provincias mineras del Cusco
                  </h3>
                  <small>Por José Víctor Salcedo La República - Cusco</small>
                </a>
              </div>
              <div className="col-sm-4 item-post">
                <a href="./unp-invierte-apenas-5-canon-investigacion">
                  <div className="container-img">
                    <img
                      src={Fondo2}
                      alt="UNP invierte apenas el 5% del canon en investigación"
                    />
                  </div>

                  <h3 className="mt-2">
                    UNP invierte apenas el 5% del canon en investigación
                  </h3>
                  <small>Por Gustavo Guarnizo – Radio Cutivalú</small>
                </a>
              </div>
              <div className="col-sm-4 item-post">
                <a
                  href="https://ojo-publico.com/2076/megantoni-el-distrito-mas-rico-de-cusco-acorralado-por-la-pobreza"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="container-img">
                    <img
                      src={Fondo3}
                      alt="Megantoni: el distrito más rico de Cusco convive con la pobreza y las sospechas de corrupción"
                    />
                  </div>

                  <h3 className="mt-2">
                    Megantoni: el distrito más rico de Cusco convive con la
                    pobreza y las sospechas de corrupción
                  </h3>
                  <small>Por Clarys Cárdenas – Ojo Público</small>
                </a>
              </div>
              <div className="col-sm-4 item-post">
                <a href="./deuda-corrupcion-como-herencia-municipio-abancay">
                  <div className="container-img">
                    <img
                      src={Fondo4}
                      alt="Deuda y corrupción como herencia en el municipio de Abancay"
                    />
                  </div>

                  <h3 className="mt-2">
                    Deuda y corrupción como herencia en el municipio de Abancay
                  </h3>
                  <small>Por Milagros Portilla - La República - Apurímac</small>
                </a>
              </div>
              <div className="col-sm-4 item-post">
                <a href="./cerro-verde-deficiencias-monitoreos-participativos">
                  <div className="container-img">
                    <img
                      src={Fondo5}
                      alt="Cerro Verde y las deficiencias en sus monitoreos participativos"
                    />
                  </div>

                  <h3 className="mt-2">
                    Cerro Verde y las deficiencias en sus monitoreos
                    participativos
                  </h3>
                  <small>Por Mabel Cáceres y Josué del Mar – El Búho</small>
                </a>
              </div>
              <div className="col-sm-4 item-post">
                <a href="./loreto-migajas-para-hijos-oro-negro">
                  <div className="container-img">
                    <img
                      src={Fondo6}
                      alt="Loreto: Migajas para los hijos del “oro negro"
                    />
                  </div>

                  <h3 className="mt-2">
                    Loreto: Migajas para los hijos del "oro negro"
                  </h3>
                  <small>Por Luz Marina Herrera – La Región</small>
                </a>
              </div>
              <div className="col-sm-4 item-post">
                <a href="./santiago-pachas-pueblo-agoniza-sed">
                  <div className="container-img">
                    <img
                      src={Fondo7}
                      alt="Santiago de Pachas: Un pueblo que agoniza de sed"
                    />
                  </div>

                  <h3 className="mt-2">
                    Santiago de Pachas: Un pueblo que agoniza de sed
                  </h3>
                  <small>
                    Por Rufino Motta Huyhua – La República - Moquegua
                  </small>
                </a>
              </div>
              <div className="col-sm-4 item-post">
                <a
                  href="https://convoca.pe/investigacion/mas-de-1500-toneladas-de-oro-se-exportaron-desde-el-peru-sin-que-se-sepa-quien-las"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="container-img">
                    <img
                      src={Fondo8}
                      alt="Más de 1500 toneladas de oro se exportaron desde el Perú sin que se sepa quién las extrajo"
                    />
                  </div>

                  <h3 className="mt-2">
                    Más de 1500 toneladas de oro se exportaron desde el Perú sin
                    que se sepa quién las extrajo
                  </h3>
                  <small>Por Fiorella Montaño - Convoca</small>
                </a>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default Home;
